<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">

      <div class="d-flex justify-content-between w-100 p-3">
        <h5 style="font-size: 1vw !important"> اولویت بندی مسئله/ {{$route.params.title}} </h5>
        <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
      </div>
      <div class="d-flex justify-content-end">


        <div  class="d-flex" v-if="allItems.length" >
          <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"  v-if="modalMessage &&  allItems.length && !status_show" @click="modalMessageShowModal=true">   دلایل عدم تایید</a>

<!--          <a   :href="`${this.download_url}/PrioritizingIssue/all/pdf/by/id/${id_route}?token=${$cookies.get('id_login')}`"
             style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
            PDF</a>-->

        </div>

      </div>
      <center>
        <div class="alert alert-info" style="width: 10vw;" v-if="modalMessage && !allItems.length" @click="modalMessageShowModal=true">دلایل عدم تایید</div>
        <div dir="rtl" class="modal__error slide-top" v-show="modalMessageShowModal" style="z-index: 999999999999999; top: 40%;">
          <div>
            <p>دلایل عدم تایید</p>
            <p @click="modalMessageShowModal=!modalMessageShowModal">❌</p>
          </div>
          <div>
            <div class="bg-white w-100 rounded p-3 text-right">
              <p>{{modalMessageShow}}</p>
            </div>

            <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
              <button @click="modalMessageShowModal=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
            </div>
          </div>
        </div>
      </center>
      <div class="table-responsive p-5">
         <center v-if="!allItems.length">
          در انتظار تکمیل / بروزرسانی کاربرگ توسط {{$route.params.title}}
        </center>
        <center v-else>
           <div v-if="status_show" class="alert alert-success">
            تایید نهایی   شرکت {{$route.params.title}} انجام شد
          </div>
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table v-show="allItems.length" class="table table-striped">
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>


            <th rowspan="2"><strong>مسئله</strong></th>
            <th colspan="6"><strong>نماگر وضعیت مسئله</strong></th>
          </tr>
          <tr>
            <th>امتیاز جذابیت
              (از 1)
            </th>
            <th>امتیاز توانمندی
              (از 1)
            </th>
            <th>امتیاز نهایی مسئله
              (از 1)
            </th>
            <th v-if="true">اولویت مسئله</th>
            <th>
              انتخاب مسئله اولویت دار
            </th>
            <th>مستندات</th>

          </tr>
          <tr style="background-color: #fff;" v-for="(item, index) in allItems">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td >
              <div class="d-flex">
                <input  :value="item.prioritizing_issue && item.prioritizing_issue.attractiveness_soccer" :id="`inputFxOne_${item.id}`" :data-number="item.id" @keyup="checkValueFxOne" type="number" max="1"
                        min="0" class="form-control">
              </div>
              </td>

            <td>
              <div class="d-flex">
                <input  :value="item.prioritizing_issue && item.prioritizing_issue.ability_soccer" :id="`inputFxTwo_${item.id}`" :data-number="item.id" @keyup="checkValueFxTwo" type="number"
                       max="1" min="0" class="form-control">
              </div>
            </td>
            <td><input  :id="`result_${item.id}`"
                       type="text"
                       :value="item.prioritizing_issue && item.prioritizing_issue.result_soccer"
                       class="form-control"></td>
            <td  v-if="true"><input
                :value="item.prioritizing_issue && item.prioritizing_issue.order"
                :id='`order_${item.id}`' type="number" class="form-control"></td>
            <td ><input

                :value="1"
                :checked="item.prioritizing_issue && item.prioritizing_issue.is_show"
                :id='`is_show_${item.id}`' type="checkbox" style="transform: translateY(0.4vw); width: 1.5vw; height: 1.5vw;"></td>
            <td>
              <p @click.prevent="AddDocumentMethod(item.id,item.title)" class="btn p-2 btn-submit-1 btn-primary">آپلود مستندات</p>
            </td>

          </tr>


          </tbody>
        </table>

      </div>
        <hr v-if="allItems.length">
        <div v-if="allItems.length" class="d-flex align-items-center justify-content-center mb-3">
          <a   :href="`${this.download_url}/PrioritizingIssue/all/word/by/id/${id_route}?token=${$cookies.get('id_login')}`" style="margin-left: 2vw;margin-top: 1.3vw;"
               class="btn btn-primary btn-submit-1">خروجی Word</a>
          <p @click.prevent="exportDocs"   style="margin-left: 2vw;margin-top: 2.5vw;"
             class="btn btn-primary btn-submit-1">خروجی مستندات</p>
          <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green " class="btn btn-primary btn-submit-1 "

                @click="acceptComplete"
          >
            <div v-if="!status_loading">

              <span  >  تایید </span>
            </div>
            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
          <a     style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
                 @click="acceptComplete2"
          >
            <div v-if="!status_loading2">
              <span >عدم تایید</span>
            </div>

            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
        </div>
      </div>
      <center >
        <button
            v-show="allItems.length"
            @click="store"
            style="margin-top: 1.3vw;margin-left: 2vw;  margin-bottom: 1vw;" class="btn btn-primary btn-submit-1">ذخیره
        </button>
      </center>



      <div v-show="fxOne" class="modal__error slide-top" style="width: 80vw; z-index: 9999">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th style="width: 1vw;"><strong>ردیف</strong></th>


            <th><strong>توانمندی</strong></th>
            <th style="width: 1vw;"><strong>وزن </strong></th>
            <th  ><strong> {{title}} </strong></th>



          </tr>
          <tr>
            <td>1</td>
            <td>دسترسی به فناوری (امتیاز)</td>
            <td>0.2</td>
            <td><input v-model="num1" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>2</td>
            <td>منابع مالی موجود (م. ریال )</td>
            <td>0.3</td>
            <td><input  v-model="num2" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>3</td>
            <td>سرمایه انسانی متخصص (نفر)</td>
            <td>0.3</td>
            <td><input  v-model="num3" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>4</td>
            <td>مکانات و زیرساخت (امتیاز)</td>
            <td>0.2</td>
            <td><input  v-model="num4" type="number" class="form-control"></td>
            </tr>

          </tbody>
        </table>
        <center>
          <button
            @click="calcOne"
             style="margin-top: 1.3vw;margin-left: 2vw; margin-right: 1vw;"  class="btn btn-primary btn-submit-1">ذخیره

             </button>
        </center>
      </div>

      <div v-show="fxTwo" class="modal__error slide-top" style="width: 80vw; z-index: 9999">

        <table class="table table-striped">
          <tbody>
          <tr>
            <th style="width: 1vw;"><strong>ردیف</strong></th>


            <th><strong>جذابیت</strong></th>
            <th style="width: 1vw;"><strong>وزن </strong></th>
            <th  ><strong> {{title}} </strong></th>



          </tr>
          <tr>
            <td>1</td>
            <td>خلق ارزش عمومی (امتیاز)</td>
            <td>0.4</td>
            <td><input  v-model="num1" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>2</td>
            <td>صرفهجویی بودجه (م. ریال)</td>
            <td>0.3</td>
            <td><input  v-model="num2" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>3</td>
            <td>مدت زمان بازگشت سرمایه (سال)</td>
            <td>0.3</td>
            <td><input  v-model="num3" type="number" class="form-control"></td>

          </tr>

          </tbody>
        </table>
        <center>
          <button
              @click="calcTwo"
              style="margin-top: 1.3vw;margin-left: 2vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ذخیره
          </button>
        </center>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div class="modal__error bg-white" style="z-index: 9699; direction: rtl; width: 54vw; overflow-y: scroll; height: 35vw;" v-show="documentsModal">
    <div class="d-flex justify-content-between">
      <p>{{titleDoc}}</p>
      <p id="btn2_p" @click.prevent="documentsModal=!documentsModal">❌</p>
    </div>
    <hr>
    <div class="d-flex flex-column" >
      <label class="required text-end">     عنوان مستندات پیوست  </label>
      <input id="title" v-model="title_attach" type="text" class="form-control">
    </div>
    <div class="d-flex flex-column" >
      <label class="required text-end">      فایل   پیوست  </label>
      <label class="input input--file">

        <input   id="file" type="file" class="input__field" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv" required>
        <span class="input__support">
    <span class="input__helper"></span>
    </span>
      </label>
    </div>

    <div id="showBar" style="display:none;">
      <div class="progress">
        <div class="progress-bar" role="progressbar" id="progress_bar"  :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <p id="progress"></p>
    </div>
    <center class="my-2" >
      <button id="btn_p" @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
      <hr class="my-3 w-100" >
    </center>
    <div v-if="!documents.length">موردی یافت نشد!</div>
    <table  class="table table-striped bg-white" v-if="documents.length">
      <thead >
      <tr>
        <th ><strong> عنوان مستند    </strong></th>
        <th><strong>فایل مستند</strong></th>
        <th  style="width: 1vw;"><strong>عملیات  </strong></th>
      </tr>
      </thead>
      <tbody>

      <tr class="bg-white" v-for="(item) in documents">
        <td>{{item.text}}</td>
        <td>
          <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
        </td>
        <td >
          <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

        </td>
      </tr>
      </tbody>


    </table>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="delete_fileModal=!delete_fileModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
import Formula from "@/components/images/formula.vue";
import login from "@/views/auth/Login.vue";
import router from "@/router";

const toast = useToast();

export default {
  computed: {},
  components: {
    Formula,
    Sidebar,
    splash
  },
  data() {
    return {
      delete_fileModal: false,
      documents: [],
      id_file: '',
      progress: '',
      documentsModal: false,
      title_attach: '',

      status_loading2: false,
      allItems: [],
      fxOne: false,
      fxTwo: false,
      title: '',
      id: '',
      num1: '',
      num2: '',
      num3: '',
      num4: '',
      id_route: this.$route['params']['id'],
      status_show: false,
      status_loading: false,
      infoCancelled: false,
      text_info: '',
      modalMessage: false,
      modalMessageShowModal: false,
      modalMessageShow: '',

    }
  },
  methods: {
    exportDocs() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id', this.id_route)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Prioritizing_Issue/export_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.download_link) {
              // ایجاد یک المان a مخفی برای دانلود
              const link = document.createElement('a');
              link.href = response.download_link;
              link.download = 'documents.zip'; // یا هر نام دیگری که می‌خواهید
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              toast.info('دانلود شروع شد');
            } else if (response.error) {

              // نمایش پیام خطا به کاربر
              toast.error('خطا در دریافت فایل: ' + response.error);
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },
    deleteMethodFileSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Prioritizing_Issue/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    allDocsMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/all_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length=0
            response.all.forEach((item)=>{
              this.documents.push(item)
            })


          })
          .catch();
    },
    deleteMethodFile(id){
      this.id_file = id
      this.delete_fileModal = true
    },
    addDocs() {
      const token = this.$cookies.get('token')
      const id_item = this.id
      const url = this.base_url
      const file = document.querySelector('#file').files[0];
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('text', this.title_attach);
      formdata.append('file', file);
      formdata.append('id', this.id);
      formdata.append('company_id', this.id_route)

      var xhr = new XMLHttpRequest();
      xhr.open('POST', `${this.base_url}/Prioritizing_Issue/add_doc`, true);

      // Listen to the progress event
      xhr.upload.onprogress = function(event) {
        if (event.lengthComputable) {
          document.getElementById("showBar").style.display = 'block';
          document.getElementById("btn2_p").style.visibility= 'hidden'
          document.getElementById("btn_p").style.visibility= 'hidden'
          var progress = ((event.loaded / event.total) * 100).toFixed();
          // Update progress UI here
          // For example:
          this.progress = progress
          document.getElementById("progress").innerText = `${progress}%`;
          document.getElementById("progress_bar").style.width = `${progress}%`;
        }
      };

      xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // Handle successful upload
            var response = JSON.parse(xhr.responseText);
            if (response.error) {
              toast.error(response.error);
              ;

              document.getElementById("showBar").style.display = 'none';
              document.getElementById("btn2_p").style.visibility= 'visible'
              document.getElementById("btn_p").style.visibility= 'visible'
              return false;
            } else {
              toast.success(response.message);
              file.value = '';
              this.title_attach = '';
              document.querySelector('#title').value = ''
              document.querySelector('#file').value = ''
              document.getElementById("showBar").style.display = 'none';
              document.getElementById("btn2_p").style.visibility= 'visible'
              document.getElementById("btn_p").style.visibility= 'visible'

            }
          } else {
            // Handle upload error
            console.error('Upload error:', xhr.status);
          }
        }
      };

      // Set headers
      for (var pair of myHeaders.entries()) {
        xhr.setRequestHeader(pair[0], pair[1]);
      }

      // Send the request with form data
      xhr.send(formdata);
      this.allDocsMethod(this.id);
      this.title_attach = '';

    },
    AddDocumentMethod(id,title){
      this.documentsModal = true
      this.id = id
      this.allDocsMethod(id)
    },
    acceptComplete(){
      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.status_show) {
          this.text_info = ''
          this.infoCancelled = true
          return;
        }
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
              this.infoCancelled = false

            }

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Prioritizing_Issue/update_complete_by_mother/${this.id_route}`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    calcOne(){
      this.fxOne=!this.fxOne

    },
    calcTwo(){
      this.fxTwo=!this.fxTwo

    },
    fxOneMethod(title,id){
      this.fxOne=!this.fxOne
      this.title = title
      this.id = id
    },
    fxTwoMethod(title,id){
      this.fxTwo=!this.fxTwo
      this.title = title
      this.id = id

    },
    CalcNumber(num1, num2,id) {
      const one = document.getElementById(num1)
      const two = document.getElementById(num2)
        document.querySelector(`#result_${id}`).value =parseFloat(one.value) * parseFloat(two.value) < 0 ? 0 : parseFloat(one.value) * parseFloat(two.value)
    },
    checkValueFxOne(event) {
      const inputValue = parseFloat(event.target.value);
      if (inputValue > 1) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'
        return false;

      } else if (inputValue < 0) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'

        return false;

      }
      document.querySelector(`#${event.target.id}`).style.border = '1px solid #777'
      return this.CalcNumber(`inputFxTwo_${event.target.dataset.number}`, `inputFxOne_${event.target.dataset.number}`,  event.target.dataset.number)


    },
    checkValueFxTwo(event) {
      const inputValue = parseFloat(event.target.value);
      if (inputValue > 1) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'
        return false;

      } else if (inputValue < 0) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'

        return false;

      }
      document.querySelector(`#${event.target.id}`).style.border = '1px solid #777'
      return this.CalcNumber(`inputFxTwo_${event.target.dataset.number}`, `inputFxOne_${event.target.dataset.number}`,  event.target.dataset.number)

    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {
              this.allItems.push(item)

            })
            if (response.message){
              this.modalMessage = true
              this.modalMessageShow = response.message
            }
          })
          .catch();
    },
    store(){
      let obj = []
      this.allItems.forEach((ele)=>{
        const fxOne = document.getElementById(`inputFxOne_${ele.id}`).value
        const fxTwo = document.getElementById(`inputFxTwo_${ele.id}`).value
        const result =  document.getElementById(`result_${ele.id}`).value
        const order =  document.getElementById(`order_${ele.id}`).value
        const is_show =  document.getElementById(`is_show_${ele.id}`).checked ? 1 : 0
        const item = {
          'problem_identifications_id': ele.id,
          'attractiveness_soccer': fxOne,
          'ability_soccer': fxTwo,
          'result_soccer': result,
          'order': order,
          'is_show': is_show,

          'id': ele.prioritizing_issue ? ele.prioritizing_issue.id : null
        }
        obj.push(item)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.all()

          })
          .catch();

    },
    checkIsMother(){
      if (!this.is_mother){
        router.push('/')
      }

    }
  },
  mounted() {
    this.all()
    this.checkIsMother()
  },

}
</script>
<style scoped lang="scss">
tr {
  background-color: #fff;
}
.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}

.input:hover .input__support {
  border-color: #9fa8b2;
}
.input:hover .input__support:before {
  color: #7d8a96;
}
.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}
.input__text sup {
  color: #fe4f3e;
  cursor: help;
}
.input .input__support:before {
  display: none;

}
.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__field:focus + .input__support {
  border-color: #037DE4;
}
.input__field:valid + .input__support {
  border-color: #3742FA;
}
.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}
.input__field:valid + .input__support .input__helper:before {
  content: "یک فایل انتخاب شده است";
  color: #7d8a96;
}
.input__field:invalid + .input__support:before {
  content: "file_upload";
}
.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}
.input__support {
  display: flex !important;
  align-items: center;
}
.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}
.input--file {
  cursor: pointer;
}
.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}
</style>